<div class="custom-overlay" (click)="onOverlayClick($event)"></div>
<div class="container">
  <div class="inner">
    <div class="close-btn-mobile" (click)="onClosePopup()">
      <img alt="Close" src="/assets/icons/close-icon.svg">
    </div>
    <div class="title">
      <span [fiTranslation]="errorTitle" [replaceKeys]="replaceKeys"></span>
    </div>
    <div class="description">
      <span [fiTranslation]="errorDescription" [replaceKeys]="replaceKeys"></span>
    </div>
  </div>
</div>
